var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: " d-flex justify-content-start align-items-center " },
          [
            _vm.is_entity_manager_only !== true
              ? [
                  _vm.edit_users !== true
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            on: {
                              click: function($event) {
                                _vm.edit_users = true
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("add")
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.current_managers.length > 0
              ? _c("h3", [_vm._v("Assigned")])
              : _c("h3", [_vm._v("Assign managers")])
          ],
          2
        ),
        _vm._v(" "),
        _vm._l(_vm.current_managers, function(current_manager) {
          return _c("div", [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-center"
              },
              [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(current_manager.email) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(current_manager.first_name) +
                      " " +
                      _vm._s(current_manager.last_name) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-outline-secondary btn-sm",
                    class: {
                      disabled:
                        _vm.isCurrentUser(current_manager) ||
                        _vm.is_entity_manager_only === true
                    },
                    on: {
                      click: function($event) {
                        _vm.removeCurrentManager(current_manager)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: current_manager.id,
                      expression: "current_manager.id"
                    }
                  ],
                  attrs: { type: "hidden", name: "entity_data->users_array[]" },
                  domProps: { value: current_manager.id },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(current_manager, "id", $event.target.value)
                    }
                  }
                })
              ]
            )
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.edit_users === true
      ? _c(
          "div",
          [
            _c("search-user", {
              attrs: {
                table_laravel_route_uri: _vm.table_laravel_route_uri,
                search_user_uri: _vm.search_user_uri,
                options: _vm.options
              },
              on: {
                selected_user_emit: _vm.selectedUsersEvent,
                close_search_event: _vm.SearchClosed
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8199476", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8199476","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/entities/EntityManagers.vue
// module id = 733
// module chunks = 0